<template>
  <div
      @keyup.enter="login"
      class="Login"
  >
    <LoginBody ref="loginBody"/>
    <LoginFooter/>
  </div>
</template>
<script>
import {mapActions} from 'vuex';
import LoginBody from './loginBody';
import LoginFooter from "./loginFooter";

export default {
  name: 'Login',
  components: {
    LoginBody,
    LoginFooter
  },
  created() {
    const token = localStorage.getItem('accessToken');
    if (token) {
      this.changeAuth({
        seqUser: localStorage.getItem('seqUser'),
        seqManager: localStorage.getItem('seqManager'),
        userEmail: localStorage.getItem('userEmail'),
        userName: localStorage.getItem('userName'),
        accessToken: token,
        //refreshToken: res.data.token.refreshToken,
        isAuth: true,
      });
    }
  },
  methods: {
    ...mapActions(['changeAuth']),
    login() {
      this.$refs.loginBody.login();
    }
  }
};
</script>